var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.499756,
    y: 0.500122,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "white",
    stroke: "#0258a1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9956 23.0002C13.7978 22.9994 13.6047 22.9399 13.4407 22.8293C13.2767 22.7188 13.1492 22.5621 13.0743 22.379C12.9994 22.196 12.9804 21.9949 13.0198 21.8011C13.0592 21.6072 13.1551 21.4295 13.2956 21.2902L17.8956 16.7102C17.9893 16.6172 18.0637 16.5066 18.1145 16.3848C18.1652 16.2629 18.1914 16.1322 18.1914 16.0002C18.1914 15.8682 18.1652 15.7375 18.1145 15.6156C18.0637 15.4937 17.9893 15.3831 17.8956 15.2902L13.2956 10.7102C13.2018 10.6172 13.1274 10.5066 13.0767 10.3848C13.0259 10.2629 12.9998 10.1322 12.9998 10.0002C12.9998 9.86817 13.0259 9.73746 13.0767 9.61561C13.1274 9.49375 13.2018 9.38315 13.2956 9.29018C13.4829 9.10393 13.7364 8.99939 14.0006 8.99939C14.2648 8.99939 14.5182 9.10393 14.7056 9.29018L19.2956 13.8802C19.8574 14.4427 20.1729 15.2052 20.1729 16.0002C20.1729 16.7952 19.8574 17.5577 19.2956 18.1202L14.7056 22.7102C14.6121 22.8029 14.5013 22.8762 14.3795 22.926C14.2576 22.9757 14.1272 23.0009 13.9956 23.0002Z",
    fill: "#0258a1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.27362a2eb9035c137b3e87cb3efdf203.svg";
export { ForwardRef as ReactComponent };